import { useState } from 'react';
import { defaultBusinessProfile, fetchBusinessProfile } from '../lib/businessProfile';
import { downloadHealthPdf, shareHealthPdf } from '../lib/healthPdf';

export default function HealthReportActions({
  report,
  vehicle,
  booking,
  customer,
  className = 'quote-toolbar',
}) {
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState('');
  const [ok, setOk] = useState('');

  if (!report || report.status !== 'finalized') return null;

  async function run(share) {
    setBusy(true);
    setError('');
    setOk('');
    try {
      const business = (await fetchBusinessProfile()) || defaultBusinessProfile;
      const context = { business, vehicle, booking, customer };
      if (share) {
        const result = await shareHealthPdf(report, context);
        setOk(result === 'shared' ? 'Health report shared.' : 'Sharing unavailable — PDF downloaded instead.');
      } else {
        await downloadHealthPdf(report, context);
        setOk('Health report PDF ready.');
      }
    } catch (err) {
      setError(err?.message || 'Could not export health report.');
    } finally {
      setBusy(false);
    }
  }

  return (
    <div>
      {error ? <p className="form-error">{error}</p> : null}
      {ok ? <p className="form-ok">{ok}</p> : null}
      <div className={className}>
        <button type="button" className="ghost" disabled={busy} onClick={() => run(false)}>
          {busy ? 'Preparing…' : 'Download PDF'}
        </button>
        <button type="button" className="primary" disabled={busy} onClick={() => run(true)}>
          {busy ? 'Preparing…' : 'Share PDF'}
        </button>
      </div>
    </div>
  );
}
